import { render, staticRenderFns } from "./ChannelGroupSelect.vue?vue&type=template&id=2ced4bcf&"
import script from "./ChannelGroupSelect.vue?vue&type=script&lang=js&"
export * from "./ChannelGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports